import React from 'react'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import ReactTooltip from 'react-tooltip';

export default class DetalhesPedido extends React.Component {
  getReservaBadgeClass(situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s === 'APROVADO' || s === 'CONFIRMADO') return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('REEMBOLSO')) return 'vx-gp-badge--cancelado';
    if (s.includes('EM_ABERTO') || s.includes('PENDENTE') || s.includes('AGUARDANDO')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  exibirDadosCrianca (crianca) {
    if (crianca) {
      return (
        <React.Fragment>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Criança de colo</span>
            <span className="vx-gp-detail-value">{capitalizarTodasPrimeirasLetras(crianca.nome)}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Doc. criança</span>
            <span className="vx-gp-detail-value">{crianca.documentoCriacaComFoto}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Nasc. criança</span>
            <span className="vx-gp-detail-value">{crianca.dtNascimentoCrianca}</span>
          </div>
        </React.Fragment>
      )
    }
  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      // eslint-disable-next-line no-param-reassign
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibirIconeObservacao(reserva) {
    if(!reserva.observacao){
      return ''
    }
    return <span className="align-self-center tooltip-info" style={{marginLeft: '4px'}}>
                <a data-tip data-for={`situacao-reserva-${reserva.id}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#FF6A00', fontSize: '14px' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`situacao-reserva-${reserva.id}`}
                                type="dark" effect="solid">
                    <div className="row">{reserva.observacao}</div>
                  </ReactTooltip>
                </div>
              </span>
  }

  exibirPassageiros(reservas, delimitacao, pedido){
    return reservas.map(reserva => (
      <div key={reserva.id} className="vx-gp-detail-card">
        <div className="vx-gp-detail-card-header">
          <div className="vx-gp-detail-card-title">
            <span className="material-icons">confirmation_number</span>
            Bilhete #{reserva.id}
          </div>
          <span className={`vx-gp-detail-status-badge ${this.getReservaBadgeClass(reserva.situacaoReserva)}`}>
            {capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_',' '))}
            {this.exibirIconeObservacao(reserva)}
          </span>
        </div>
        <div className="vx-gp-detail-grid">
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Rota</span>
            <span className="vx-gp-detail-value">{reserva.rota}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Trecho</span>
            <span className="vx-gp-detail-value">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Ponto de embarque</span>
            <span className="vx-gp-detail-value">{reserva.embarque}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Plataforma</span>
            <span className="vx-gp-detail-value">{reserva.plataformaEmbarque}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Delimitação</span>
            <span className="vx-gp-detail-value">{delimitacao}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Partida</span>
            <span className="vx-gp-detail-value">{reserva.dataHoraPartida}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Nome passageiro</span>
            <span className="vx-gp-detail-value">{reserva.passageiroDto.nome}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">DDI / Telefone</span>
            <span className="vx-gp-detail-value">
              {reserva.passageiroDto.siglaPais} {reserva.passageiroDto.ddi}
              {reserva.passageiroDto.telefone ? ` · ${reserva.passageiroDto.telefone}` : ' · -'}
            </span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">CPF</span>
            <span className="vx-gp-detail-value">{reserva.passageiroDto.cpfPassageiro}</span>
          </div>
          {pedido.emailComprador && (
            <div className="vx-gp-detail-field">
              <span className="vx-gp-detail-label">Email</span>
              <span className="vx-gp-detail-value">{pedido.emailComprador}</span>
            </div>
          )}
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Id itinerário</span>
            <span className="vx-gp-detail-value">{reserva.itinerarioId}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Id rota</span>
            <span className="vx-gp-detail-value">{reserva.rotaId}</span>
          </div>
          {reserva.idRemarcada && (
            <div className="vx-gp-detail-field">
              <span className="vx-gp-detail-label">Reserva antiga</span>
              <span className="vx-gp-detail-value">{reserva.idRemarcada}</span>
            </div>
          )}
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Poltrona</span>
            <span className="vx-gp-detail-value">{reserva.numeroPoltrona}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Tarifa</span>
            <span className="vx-gp-detail-value">{reserva.passageiroDto.tipoEmissao}</span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Número seguro</span>
            <span className="vx-gp-detail-value">
              {reserva.numeroSeguro
                ? 'MBM-' + reserva.numeroSeguro.replace(/^(\d{4})(\d{6})(\d{1}).*/, '$1-$2-$3')
                : 'MBM-0000-000000-0'}
            </span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Valor bilhete</span>
            <span className="vx-gp-detail-value vx-gp-detail-value--price">
              {Number(reserva.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
          <div className="vx-gp-detail-field">
            <span className="vx-gp-detail-label">Taxa embarque</span>
            <span className="vx-gp-detail-value">
              {Number(reserva.taxaEmbarque).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
          {this.exibirDadosCrianca(reserva.passageiroDto.criancaDto)}
        </div>
      </div>
    ))
  }

  exibirCupomDesconto (pedido) {
    const temCupom = pedido.porcentagemCupom;
    return (
      <div className={`vx-gp-coupon-card${temCupom ? '' : ' vx-gp-coupon-card--vazio'}`}>
        <span className="material-icons vx-gp-coupon-icon">local_offer</span>
        <div className="vx-gp-coupon-info">
          <span className="vx-gp-coupon-label">Cupom de desconto</span>
          {temCupom ? (
            <React.Fragment>
              <span className="vx-gp-coupon-value">
                -{Number(pedido.valorTotalDesconto).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </span>
              <span className="vx-gp-coupon-desc">{pedido.descricaoCupom} ({pedido.porcentagemCupom}%)</span>
            </React.Fragment>
          ) : (
            <span className="vx-gp-coupon-desc">Nenhum cupom aplicado</span>
          )}
        </div>
      </div>
    )
  }

  render () {
    if (!this.props.pedido.exibirDetalhe) {
      return ''
    }
    return (
      <div className="vx-gp-details">
        {this.exibirCupomDesconto(this.props.pedido)}
        {this.exibirPassageiros(this.props.pedido.reservas, this.props.pedido.delimitacao, this.props.pedido)}
      </div>
    )
  }
}
